import { Form } from 'antd';

export const useForm = Form.useForm;
